/* FIELDWRKS theme JS — header, drawer, search, announcement, game loader, cart badge.
   Classic deferred script; no framework. */
(function () {
  function initLineup(scope) {
    (scope || document).querySelectorAll('[data-fw-lineup]').forEach(function (lineup) {
      var tabs = lineup.querySelectorAll('[data-fw-tab]');
      var rows = lineup.querySelectorAll('[data-fw-row]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-fw-tab');
          tabs.forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
          rows.forEach(function (row) { row.classList.toggle('is-active', row.getAttribute('data-fw-row') === target); });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initLineup(); });
  else initLineup();
  document.addEventListener('shopify:section:load', function (e) { initLineup(e.target); });
})();

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  // `overflow: hidden` is not a reliable scroll lock on mobile Safari or Chrome
  // for Android, so the body is pinned at its current offset instead.
  var scrollLockY = 0;
  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      if (html.classList.contains('fw2-scroll-locked')) return;
      scrollLockY = window.pageYOffset || html.scrollTop || 0;
      document.body.style.top = (-scrollLockY) + 'px';
      html.classList.add('fw2-scroll-locked');
    } else {
      if (!html.classList.contains('fw2-scroll-locked')) return;
      html.classList.remove('fw2-scroll-locked');
      document.body.style.top = '';
      window.scrollTo(0, scrollLockY);
    }
  }

  // Everything outside an open overlay becomes inert so focus cannot escape it.
  function setInert(exceptRoot, on) {
    var targets = [document.getElementById('MainContent'), document.querySelector('.page-wrapper > footer')];
    var header = document.querySelector('[data-fw2-header]');
    if (header) Array.prototype.forEach.call(header.children, function (el) { if (!el.contains(exceptRoot)) targets.push(el); });
    targets.forEach(function (el) { if (!el) return; if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
  }

  function initFw2(scope) {
    var root = scope || document;

    // shop tabs (homepage lineup)
    root.querySelectorAll('[data-fw2-shop]').forEach(function (shop) {
      var tabs = shop.querySelectorAll('[data-fw2-tab]');
      var rows = shop.querySelectorAll('[data-fw2-row]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-fw2-tab');
          tabs.forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-pressed', a ? 'true' : 'false'); });
          rows.forEach(function (row) { row.classList.toggle('is-active', row.getAttribute('data-fw2-row') === target); });
        });
      });
    });

    root.querySelectorAll('[data-fw2-header]').forEach(function (header) {
      if (header.__fw2Bound) return;
      header.__fw2Bound = true;

      // ---- announcement strip: a right-to-left marquee; dismissal lasts the session
      var announce = header.querySelector('[data-fw2-announce]');
      if (announce) {
        try { if (sessionStorage.getItem('fw2-announce-closed') === '1') document.documentElement.classList.add('fw2-announce-closed'); } catch (e) {}
        var close = announce.querySelector('[data-fw2-announce-close]');
        if (close) close.addEventListener('click', function () {
          document.documentElement.classList.add('fw2-announce-closed');
          try { sessionStorage.setItem('fw2-announce-closed', '1'); } catch (e) {}
          window.dispatchEvent(new Event('resize'));
        });
        // A short message list would loop with a visible gap, so repeat each run
        // until it is at least as wide as the strip before the track scrolls.
        var track = announce.querySelector('[data-fw2-announce-track]');
        if (track && !reduced.matches) {
          var runs = track.querySelectorAll('.fw2-announce__run');
          if (runs.length === 2) {
            var guard = 0;
            while (runs[0].offsetWidth < announce.offsetWidth && guard < 6) {
              runs[0].innerHTML += runs[0].innerHTML;
              guard++;
            }
            if (guard > 0) runs[1].innerHTML = runs[0].innerHTML;
          }
        }
      }

      // ---- desktop dropdowns (hover + click + keyboard)
      header.querySelectorAll('[data-fw2-nav-item]').forEach(function (item) {
        var btn = item.querySelector('[data-fw2-nav-toggle]');
        var sub = item.querySelector('[data-fw2-sub]');
        if (!btn || !sub) return;
        var hoverTimer;
        function open() { clearTimeout(hoverTimer); sub.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
        function shut() { sub.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
        btn.addEventListener('click', function () { if (sub.hidden) open(); else shut(); });
        item.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) open(); });
        item.addEventListener('mouseleave', function () { hoverTimer = setTimeout(shut, 120); });
        item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) shut(); });
        item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sub.hidden) { shut(); btn.focus(); } });
        document.addEventListener('click', function (e) { if (!sub.hidden && !item.contains(e.target)) shut(); });
      });

      // ---- mobile drawer: slides in from the left; ×, backdrop, Esc or a right-to-left swipe closes it
      var drawer = header.querySelector('[data-fw2-drawer]');
      var openBtn = header.querySelector('[data-fw2-menu-open]');
      if (drawer && openBtn) {
        var panel = drawer.querySelector('[data-fw2-drawer-panel]');
        function setOpen(on) {
          drawer.classList.toggle('is-open', on);
          drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
          openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
          document.documentElement.classList.toggle('fw2-drawer-open', on);
          lockScroll(on);
          setInert(drawer, on);
          if (on) { var first = drawer.querySelector('.fw2-drawer__close'); if (first) first.focus({ preventScroll: true }); }
          else openBtn.focus({ preventScroll: true });
        }
        openBtn.addEventListener('click', function () { setOpen(true); });
        drawer.querySelectorAll('[data-fw2-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
        drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
        if (panel) {
          var x0 = null, y0 = null;
          panel.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; panel.style.transition = 'none'; }, { passive: true });
          panel.addEventListener('touchmove', function (e) {
            if (x0 === null) return;
            var dx = e.touches[0].clientX - x0;
            if (dx < 0 && Math.abs(dx) > Math.abs(e.touches[0].clientY - y0)) panel.style.transform = 'translateX(' + dx + 'px)';
          }, { passive: true });
          panel.addEventListener('touchend', function (e) {
            if (x0 === null) return;
            var dx = e.changedTouches[0].clientX - x0; x0 = null;
            panel.style.transition = ''; panel.style.transform = '';
            if (dx < -70) setOpen(false);
          });
        }
      }

      // ---- in-header search: predictive results, debounced, back-off on 429
      var sPanel = header.querySelector('[data-fw2-search]');
      var sOpen = header.querySelector('[data-fw2-search-open]');
      if (sPanel && sOpen) {
        var input = sPanel.querySelector('[data-fw2-search-input]');
        var results = sPanel.querySelector('[data-fw2-search-results]');
        var form = sPanel.querySelector('[data-fw2-search-form]');
        var timer = null, seq = 0, firstUrl = null, backoffUntil = 0;
        function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
        function money(p) { var n = parseFloat(p); return isNaN(n) ? '' : '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
        function setSearch(on) {
          sPanel.hidden = !on;
          requestAnimationFrame(function () { sPanel.classList.toggle('is-open', on); });
          sOpen.setAttribute('aria-expanded', on ? 'true' : 'false');
          input.setAttribute('aria-expanded', 'false');
          if (on) { input.focus(); input.select(); } else { results.innerHTML = ''; firstUrl = null; }
        }
        function render(items, q) {
          firstUrl = items.length ? items[0].url : null;
          input.setAttribute('aria-expanded', items.length ? 'true' : 'false');
          if (!q) { results.innerHTML = ''; return; }
          if (!items.length) { results.innerHTML = '<p class="fw2-search__empty">Nothing found for “' + esc(q) + '”</p>'; return; }
          results.innerHTML = '<ul class="fw2-search__list" role="list">' + items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=160&') : '';
            return '<li role="option"><a class="fw2-search__item" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="fw2-search__noimg"></span>') +
              '<span class="fw2-search__text"><span class="fw2-search__title">' + esc(p.title) + '</span>' +
              '<span class="fw2-search__price">' + money(p.price) + (p.available === false ? ' · SOLD OUT' : '') + '</span></span></a></li>';
          }).join('') + '</ul>';
        }
        function lookup() {
          var q = input.value.trim();
          if (q.length < 2) { render([], ''); return; }
          if (Date.now() < backoffUntil) { timer = setTimeout(lookup, backoffUntil - Date.now()); return; }
          var mine = ++seq;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) {
              if (r.status === 429) { backoffUntil = Date.now() + (parseInt(r.headers.get('Retry-After'), 10) || 2) * 1000; return null; }
              return r.ok ? r.json() : null;
            })
            .then(function (d) {
              if (mine !== seq) return;
              var items = (d && d.resources && d.resources.results && d.resources.results.products) || [];
              render(items, d ? q : '');
            }).catch(function () { if (mine === seq) render([], q); });
        }
        sOpen.addEventListener('click', function () { setSearch(sPanel.hidden); });
        var sClose = sPanel.querySelector('[data-fw2-search-close]');
        if (sClose) sClose.addEventListener('click', function () { setSearch(false); });
        input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(lookup, 200); });
        form.addEventListener('submit', function (e) { if (firstUrl) { e.preventDefault(); window.location.href = firstUrl; } });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sPanel.hidden) { setSearch(false); sOpen.focus(); } });
        document.addEventListener('click', function (e) { if (!sPanel.hidden && !sPanel.contains(e.target) && !sOpen.contains(e.target)) setSearch(false); });
      }

      // ---- sticky state: once the hero wordmark scrolls away, paint the bar
      var pane = document.querySelector('.page-wrapper');
      var ticking = false;
      function update() {
        ticking = false;
        var mark = document.querySelector('.fw2-hero__wordmark');
        var stuck = mark ? mark.getBoundingClientRect().bottom < header.offsetHeight * 0.6 : true;
        header.classList.toggle('is-stuck', stuck);
        document.documentElement.style.setProperty('--fw2-header-h', header.offsetHeight + 'px');
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      if (pane) pane.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    // product rail tabs
    root.querySelectorAll('[data-fw-rail]').forEach(function (rail) {
      if (rail.__fwBound) return; rail.__fwBound = true;
      var tabs = rail.querySelectorAll('[data-fw-rail-tab]'), panels = rail.querySelectorAll('[data-fw-rail-panel]');
      var list = Array.prototype.slice.call(tabs);
      function select(t, moveFocus) {
        var id = t.getAttribute('data-fw-rail-tab');
        list.forEach(function (x) {
          var a = x === t;
          x.classList.toggle('is-active', a);
          x.setAttribute('aria-selected', a ? 'true' : 'false');
          x.tabIndex = a ? 0 : -1;
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-fw-rail-panel') === id); });
        if (moveFocus) t.focus();
      }
      list.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = list[(i + 1) % list.length];
          else if (k === 'ArrowLeft' || k === 'ArrowUp') n = list[(i - 1 + list.length) % list.length];
          else if (k === 'Home') n = list[0];
          else if (k === 'End') n = list[list.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });

    // hotspots: pins and list stay in sync
    root.querySelectorAll('[data-fw-hotspots]').forEach(function (hs) {
      if (hs.__fwBound) return; hs.__fwBound = true;
      var pins = hs.querySelectorAll('[data-fw-hot-pin]'), items = hs.querySelectorAll('[data-fw-hot-item]');
      function go(i) {
        pins.forEach(function (p) { var a = p.getAttribute('data-fw-hot-pin') === i; p.classList.toggle('is-active', a); p.setAttribute('aria-pressed', a ? 'true' : 'false'); });
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-fw-hot-item') === i); });
      }
      pins.forEach(function (p) { p.addEventListener('click', function () { go(p.getAttribute('data-fw-hot-pin')); }); });
      items.forEach(function (it) { it.addEventListener('click', function () { go(it.getAttribute('data-fw-hot-item')); }); });
    });

    // FAQ category filter
    root.querySelectorAll('[data-fw-faq]').forEach(function (faq) {
      if (faq.__fwBound) return; faq.__fwBound = true;
      var tabs = faq.querySelectorAll('[data-fw-faq-tab]'), items = faq.querySelectorAll('[data-fw-faq-item]');
      tabs.forEach(function (t) { t.addEventListener('click', function () {
        var id = t.getAttribute('data-fw-faq-tab');
        tabs.forEach(function (x) { var a = x === t; x.classList.toggle('is-active', a); x.setAttribute('aria-pressed', a ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = id !== 'all' && it.getAttribute('data-fw-faq-item') !== id; });
      }); });
    });

    // smooth scroll for hero CTA anchors
    root.querySelectorAll('[data-fw2-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#') { var el = document.querySelector(href); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth' }); } }
      });
    });
  }

  // ---- FW RUN: load the game script on first PLAY (or #fwrun), then replay the click
  (function gameLoader() {
    var modal = document.querySelector('[data-fw2-game]');
    if (!modal) return;
    var src = modal.getAttribute('data-fw2-game-src');
    var loading = null;
    function load() {
      if (window.__fw2GameLoaded) return Promise.resolve();
      if (loading) return loading;
      loading = new Promise(function (res, rej) {
        var s = document.createElement('script'); s.src = src; s.async = true;
        s.onload = function () { window.__fw2GameLoaded = true; res(); }; s.onerror = rej;
        document.body.appendChild(s);
      });
      return loading;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-fw2-game-open]');
      if (!btn || window.__fw2GameLoaded) return;
      e.preventDefault(); e.stopImmediatePropagation();
      load().then(function () { btn.click(); });
    }, true);
    // also load straight after the game's sign-up form posts (Shopify redirects back with ?customer_posted=true)
    var pendingSignup = false;
    try { pendingSignup = !!localStorage.getItem('fw2run-pending'); } catch (e) {}
    if (location.hash === '#fwrun' || (pendingSignup && (/customer_posted=true/.test(location.search) || /fw2-game-signup-form/.test(location.hash)))) load();
    new MutationObserver(function () {
      document.documentElement.classList.toggle('fw2-game-open', modal.classList.contains('is-open'));
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  })();

  // ---- cart opens Horizon's slide-in drawer instead of loading /cart.
  // The links keep their href so they still work without JS and on the cart page,
  // where no drawer is rendered.
  function openCartDrawer() {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(function () {
        if (typeof drawer.open === 'function') drawer.open();
      });
      return true;
    }
    return false;
  }
  window.fw2OpenCartDrawer = openCartDrawer;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('[data-fw2-cart-open]');
    if (!link) return;
    if (openCartDrawer()) e.preventDefault();
  });

  // ---- cart badge follows every cart change (add from PDP, edits in the drawer)
  function setCount(n) {
    document.querySelectorAll('[data-fw2-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
    document.querySelectorAll('[data-fw2-cart-count-text]').forEach(function (el) { el.textContent = n > 0 ? ' (' + n + ')' : ''; });
    document.querySelectorAll('[data-fw2-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart' + (n > 0 ? ', ' + n + ' item' + (n === 1 ? '' : 's') : '')); });
  }
  window.fw2SetCartCount = setCount;
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e.promise) return;
    e.promise.then(function (r) {
      var n = r && r.cart && typeof r.cart.totalQuantity === 'number' ? r.cart.totalQuantity : (r && r.detail && typeof r.detail.itemCount === 'number' ? r.detail.itemCount : null);
      if (n === null) return fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) { setCount(c.item_count); });
      setCount(n);
    }).catch(function () {});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initFw2(); });
  else initFw2();
  document.addEventListener('shopify:section:load', function (e) { initFw2(e.target); });
})();

/* Product card colour dots.
   The card photo never changes when the photo itself is hovered. Hovering a colour
   dot swaps the photo to that variant and points the card link at it; leaving the
   card restores the default colour. On touch, tapping a dot opens that colour. */
;(function () {
  if (window.__fwPcardDots) return;
  window.__fwPcardDots = true;

  function dotOf(el) { return el && el.closest ? el.closest('[data-fw-pcard-dot]') : null; }

  function state(card) {
    if (!card.__fw) {
      var img = card.querySelector('[data-fw-pcard-img]');
      card.__fw = {
        img: img,
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null,
        href: card.getAttribute('href'),
        dot: card.querySelector('[data-fw-pcard-dot].is-active')
      };
    }
    return card.__fw;
  }

  function show(card, dot) {
    var s = state(card);
    var isDefault = !dot || dot === s.dot;
    card.querySelectorAll('[data-fw-pcard-dot]').forEach(function (d) {
      d.classList.toggle('is-active', d === (dot || s.dot));
    });
    card.setAttribute('href', isDefault ? s.href : (dot.getAttribute('data-href') || s.href));
    if (!s.img) return;
    var src = isDefault ? s.src : dot.getAttribute('data-src');
    var srcset = isDefault ? s.srcset : dot.getAttribute('data-srcset');
    if (!src || s.img.getAttribute('src') === src) return;
    card.__fwWant = src;
    // Decode first so the photo never blanks while the next colour loads.
    var pre = new Image();
    if (srcset) { pre.sizes = s.img.getAttribute('sizes') || ''; pre.srcset = srcset; }
    pre.src = src;
    var apply = function () {
      if (card.__fwWant !== src) return;
      if (srcset) s.img.setAttribute('srcset', srcset); else s.img.removeAttribute('srcset');
      s.img.setAttribute('src', src);
    };
    if (pre.decode) pre.decode().then(apply, apply); else if (pre.complete) apply(); else pre.onload = pre.onerror = apply;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var dot = dotOf(e.target);
    if (!dot) return;
    var card = dot.closest('[data-fw-pcard]');
    if (card) show(card, dot);
  });

  document.addEventListener('pointerout', function (e) {
    var card = e.target.closest ? e.target.closest('[data-fw-pcard]') : null;
    if (!card || !card.__fw) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    show(card, null);
  });

  document.addEventListener('pointerdown', function (e) {
    var dot = dotOf(e.target);
    if (!dot) return;
    var card = dot.closest('[data-fw-pcard]');
    if (!card) return;
    state(card);
    card.setAttribute('href', dot.getAttribute('data-href') || card.__fw.href);
  }, { passive: true });
})();

/* Homepage video banner: since v2.69 the chooser is inline in sections/fw2-hero.liquid so the file starts downloading at parse time, not at DOMContentLoaded. */

/* ---- v2.35: segmented category switcher — the frosted indicator follows the active cell
   (clicks, the rail's arrow-key handling, or a server-rendered aria-current). ---- */
(function () {
  function sync(tabs) {
    var items = Array.prototype.slice.call(tabs.querySelectorAll('.fw-tabs__item'));
    var i = -1;
    items.forEach(function (it, k) { if (i < 0 && (it.getAttribute('aria-selected') === 'true' || it.hasAttribute('aria-current') || it.classList.contains('is-active'))) i = k; });
    tabs.style.setProperty('--n', String(items.length || 1));
    tabs.style.setProperty('--i', String(i < 0 ? 0 : i));
    items.forEach(function (it, k) { it.classList.toggle('is-active', k === (i < 0 ? 0 : i)); });
    // cells are content-sized, so the pill takes the measured box of the active cell
    var it = items[i < 0 ? 0 : i];
    if (it && it.offsetWidth) {
      tabs.style.setProperty('--gx', (it.offsetLeft - 3) + 'px');
      tabs.style.setProperty('--gw', it.offsetWidth + 'px');
    }
  }
  var all = [];
  function syncAll() { all.forEach(sync); }
  function init(tabs) {
    if (tabs.__fwTabs) return; tabs.__fwTabs = true;
    all.push(tabs);
    sync(tabs);
    requestAnimationFrame(function () { tabs.classList.add('is-ready'); });
    tabs.addEventListener('click', function (e) {
      var it = e.target.closest('.fw-tabs__item'); if (!it || !tabs.contains(it)) return;
      if (it.tagName === 'A') { setTimeout(function () { sync(tabs); }, 0); return; }
      setTimeout(function () { sync(tabs); }, 0);   // after the rail's own tab logic has run
    });
    if (window.MutationObserver) new MutationObserver(function () { sync(tabs); }).observe(tabs, { attributes: true, subtree: true, attributeFilter: ['aria-selected', 'aria-current', 'class'] });
  }
  function boot() { document.querySelectorAll('[data-fw-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', syncAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll);
  window.addEventListener('load', syncAll);
})();


/* ---- v2.39: collection switcher without a page load. Clicking a category fetches that collection's
   grid through Shopify's section rendering endpoint (?section_id=…), crossfades it into place, moves
   the glass pill and updates the URL/title with pushState. Siblings are prefetched after load so the
   swap is usually instant; back/forward replay the same swap. Falls back to a normal navigation. ---- */
(function () {
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var cache = {};
  function sectionUrl(href, id) {
    var u = new URL(href, window.location.origin);
    u.search = ''; u.hash = '';
    u.searchParams.set('section_id', id);
    return u.toString();
  }
  function fetchSection(href, id) {
    var key = sectionUrl(href, id);
    if (!cache[key]) {
      cache[key] = fetch(key, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = doc.querySelector('[data-fw-colg-body]');
          if (!body) throw new Error('no body');
          return { body: body.innerHTML, crumbs: (doc.querySelector('.fw-crumbs') || {}).outerHTML || '', title: (doc.querySelector('[data-fw-colg]') && doc.querySelector('[data-fw-colg]').getAttribute('data-fw-title')) || '', handle: (doc.querySelector('[data-fw-colg]') || { getAttribute: function () { return ''; } }).getAttribute('data-handle') };
        })
        .catch(function (e) { delete cache[key]; throw e; });
    }
    return cache[key];
  }
  function init(root) {
    if (root.__fwColg || (window.Shopify && window.Shopify.designMode)) return; root.__fwColg = true;
    var id = root.getAttribute('data-section-id');
    var tabs = root.querySelector('[data-fw-tabs]');
    var body = root.querySelector('[data-fw-colg-body]');
    if (!id || !tabs || !body || !window.fetch || !window.history || !window.history.pushState) return;
    var items = Array.prototype.slice.call(tabs.querySelectorAll('.fw-tabs__item[href]'));
    var busy = false;
    var titles = {}; titles[window.location.pathname.replace(/\/$/, '')] = document.title;   // each collection keeps its own SEO title
    function mark(href) {
      var path = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      items.forEach(function (a) {
        var on = new URL(a.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, '') === path;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
      });
    }
    function swap(href, push) {
      if (busy) return; busy = true;
      mark(href);                                   // the pill glides at once
      root.classList.add('is-switching');
      var started = Date.now();
      Promise.all([fetchSection(href, id), new Promise(function (res) { setTimeout(res, REDUCED ? 0 : 170); })])
        .then(function (r) {
          var data = r[0];
          body.innerHTML = data.body;
          var crumbs = root.querySelector('.fw-crumbs');
          if (crumbs && data.crumbs) crumbs.outerHTML = data.crumbs;
          var tkey = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
          if (data.title) titles[tkey] = data.title;
          if (titles[tkey]) document.title = titles[tkey];
          if (data.handle) root.setAttribute('data-handle', data.handle);
          if (push) history.pushState({ fwColg: href }, '', href);
          root.classList.remove('is-switching'); root.classList.add('is-entering');
          setTimeout(function () { root.classList.remove('is-entering'); }, 700);
          busy = false;
          document.dispatchEvent(new CustomEvent('fw:collection-swapped', { detail: { href: href } }));
        })
        .catch(function () { window.location.href = href; });
    }
    items.forEach(function (a) {
      var pre = function () { fetchSection(a.getAttribute('href'), id).catch(function () {}); };
      a.addEventListener('pointerenter', pre); a.addEventListener('focus', pre); a.addEventListener('touchstart', pre, { passive: true });
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var href = a.getAttribute('href'); if (!href) return;
        e.preventDefault();
        if (a.hasAttribute('aria-current')) return;
        swap(href, true);
      });
    });
    window.addEventListener('popstate', function () { swap(window.location.pathname, false); });
    if (!history.state || !history.state.fwColg) history.replaceState({ fwColg: window.location.pathname }, '', window.location.href);
    var warm = function () { items.forEach(function (a) { if (!a.hasAttribute('aria-current')) fetchSection(a.getAttribute('href'), id).catch(function () {}); }); };
    if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
  }
  function boot() { document.querySelectorAll('[data-fw-colg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

// ---- v2.54: the FW RUN badge is draggable. It loads bottom-right (CSS) and the visitor can drag it anywhere
// with a mouse or a finger; the spot is kept for the session. A tap without a drag opens the game, a drag never does.
(function dragBadge() {
  var badge = document.querySelector('.fw-play-badge');
  if (!badge || !window.PointerEvent) return;
  var KEY = 'fw-badge-pos', M = 6;
  var fx = null, fy = null, dragging = false, dragged = false, startX = 0, startY = 0, originX = 0, originY = 0, pid = null;
  function size() { return { w: badge.offsetWidth || 88, h: badge.offsetHeight || 88 }; }
  function free() { var s = size(); return { x: Math.max(0, window.innerWidth - s.w - 2 * M), y: Math.max(0, window.innerHeight - s.h - 2 * M) }; }
  function apply() {
    var f = free();
    badge.classList.add('is-free');
    badge.style.setProperty('--fx', (M + fx * f.x).toFixed(1) + 'px');
    badge.style.setProperty('--fy', (M + fy * f.y).toFixed(1) + 'px');
  }
  function setPx(x, y) {
    var f = free();
    fx = f.x ? Math.min(1, Math.max(0, (x - M) / f.x)) : 0;
    fy = f.y ? Math.min(1, Math.max(0, (y - M) / f.y)) : 0;
    apply();
  }
  try { var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (saved && isFinite(saved.fx) && isFinite(saved.fy)) { fx = saved.fx; fy = saved.fy; apply(); } } catch (e) {}
  badge.addEventListener('pointerdown', function (e) {
    if (e.button && e.button !== 0) return;
    var r = badge.getBoundingClientRect();
    dragging = true; dragged = false; pid = e.pointerId; startX = e.clientX; startY = e.clientY; originX = r.left; originY = r.top;
    try { badge.setPointerCapture(pid); } catch (err) {}
  });
  badge.addEventListener('pointermove', function (e) {
    if (!dragging || e.pointerId !== pid) return;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (!dragged && Math.abs(dx) + Math.abs(dy) < 6) return;        // a steady finger is a tap, not a drag
    if (!dragged) { dragged = true; badge.classList.add('is-dragging'); }
    setPx(originX + dx, originY + dy);
    e.preventDefault();
  });
  function end(e) {
    if (!dragging || (e && e.pointerId !== pid)) return;
    dragging = false; badge.classList.remove('is-dragging');
    try { badge.releasePointerCapture(pid); } catch (err) {}
    if (dragged) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ fx: fx, fy: fy })); } catch (err) {}
      setTimeout(function () { dragged = false; }, 400);   // swallow the click that follows a drag
    }
  }
  badge.addEventListener('pointerup', end);
  badge.addEventListener('pointercancel', end);
  window.addEventListener('click', function (e) {
    if (dragged && e.target && e.target.closest && e.target.closest('.fw-play-badge')) { e.preventDefault(); e.stopImmediatePropagation(); dragged = false; }
  }, true);
  window.addEventListener('resize', function () { if (fx !== null) apply(); });
})();

/* v2.64 (QA M2): restore the scroll position on back/forward. On desktop the theme scrolls inside
   .page-wrapper (window.scrollY is always 0), so the browser's own restoration never applies there;
   on phones the document scrolls but Horizon's navigation scripts leave the page at the top. */
(function () {
  var pane = document.querySelector('.page-wrapper');
  function scroller() {
    if (!pane) return null;
    var o = getComputedStyle(pane).overflowY;
    return (o === 'auto' || o === 'scroll') && pane.scrollHeight > pane.clientHeight ? pane : null;
  }
  function key() { return 'fw-scroll:' + location.pathname + location.search; }
  function pos() { var s = scroller(); return s ? s.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0); }
  var t;
  function save() { clearTimeout(t); t = setTimeout(function () { try { sessionStorage.setItem(key(), String(Math.round(pos()))); } catch (e) {} }, 150); }
  if (pane) pane.addEventListener('scroll', save, { passive: true });
  window.addEventListener('scroll', save, { passive: true });
  window.addEventListener('pagehide', function () { try { sessionStorage.setItem(key(), String(Math.round(pos()))); } catch (e) {} });
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var back = nav ? nav.type === 'back_forward' : (performance.navigation && performance.navigation.type === 2);
  if (!back) return;
  var y = 0;
  try { y = parseInt(sessionStorage.getItem(key()), 10) || 0; } catch (e) {}
  if (y < 1) return;
  var tries = 0;
  (function restore() {
    var s = scroller();
    if (s) s.scrollTop = y; else window.scrollTo(0, y);
    if (Math.abs(pos() - y) > 2 && tries++ < 30) requestAnimationFrame(restore);
  })();
})();
